import { CUSTOMER_CONFIG } from "../constants"
import {getAccessorialsAfterExclusion as getAccessorialsAfterExclusionSAIA} from "./saia"
import {getAccessorialsAfterExclusion as getAccessorialsAfterExclusionDefault} from "./default"

export const getAccessorialsAfterExclusion = (config)=> {
    if(config === CUSTOMER_CONFIG.SAIA){
        return getAccessorialsAfterExclusionSAIA
    }
    return getAccessorialsAfterExclusionDefault;
}
